import React, { useEffect, useState } from "react";
import { shareDataApi } from "../../../services/shareDataService";
import MainPageDialog from "../../../components/dialog";
import { AppListing } from "../../../components/AppListing/Listing.view";
import moment from "moment";
import { Loader } from "../../../components/loader/index";
import { shallowEqual, useSelector } from "react-redux";

export const billingDataCols = [
  {
    colWidth: 2,
    title: "DOS Date",
    getData: (item) => {
      return moment(item?.dos).format("MM/DD/YYYY");
    },
  },
  // {
  //     colWidth: 1,
  //     title: "Encounter",
  //     key: "encounter",
  // },
  {
    colWidth: 1,
    title: "Location",
    key: "location_name",
  },
  {
    colWidth: 1,
    title: "Provider",
    key: "provider_name",
  },
  {
    colWidth: 1,
    title: "CPTs",
    key: "procedures_codes",
    // getData: (item)=>{
    //     return item?.procedures['13519195']?.cpt_code
    // }
  },
  {
    colWidth: 1,
    title: "ICDs",
    key: "diagnosis_code",
  },
  {
    colWidth: 1,
    title: "Chr Amount",
    getData: (item) => {
      return `$${item?.charge_amount}`;
    },
  },
  {
    colWidth: 1,
    title: "Paid_Amount",
    getData: (item) => {
      return `$${item?.paid}`;
    },
  },
  {
    colWidth: 1,
    title: "Adjustment",
    getData: (item) => {
      return `$${item?.adjustment.toFixed(2)}`;
    },
  },
  {
    colWidth: 1,
    title: "Transfer",
    getData: (item) => {
      return `$${item?.transfer_amount.toFixed(2)}`;
    },
  },
  {
    colWidth: 1,
    title: "Balance",
    getData: (item) => {
      return `$${item?.open_balance.toFixed(2)}`;
    },
  },
  {
    colWidth: 1,
    title: "Responsible",
    key: "current_responsible",
  },
];

const AttchBillingData = ({ shareDataDetail, selectedChat }) => {
  const [billingData, setBillingData] = useState([]);
  //  const { selectedPatient } = useSelector(
  //      ({ providerNote }) => ({
  //          selectedPatient: providerNote.selectedPatient?.Patient,
  //         }),
  //         shallowEqual
  //     );
  const [AttachBillingData, { isLoading }] =
    shareDataApi?.endpoints?.AttachBillingData?.useLazyQuery();

  useEffect(() => {
    if (selectedChat?.patient?.mrn) {
      AttachBillingData({
        mrn: selectedChat?.patient?.mrn,
      }).then((res) => {
        console.log(res?.data?.response);
        if (res?.data?.response?.code == 0) {
          setBillingData(res?.data?.response?.data);
        }
      });
    }
  }, [selectedChat?.patient?.mrn]);

  return (
    <MainPageDialog
      title="Attach Billing Data"
      onCancelHandler={() => shareDataDetail?.closeDialog()}
      footer={true}
      footerList={[
        {
          title: "Attach",
          type: "save",
          action: () => {
            shareDataDetail?.attachHandler(shareDataDetail?.selectedFiles);
          },
        },
        {
          title: "Cancel",
          type: "cancel",
          action: () => shareDataDetail?.closeDialog(),
        },
      ]}
    >
      {isLoading && (
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[999]">
          <Loader />
        </div>
      )}
      <AppListing
        cols={billingDataCols}
        listData={billingData || []}
        selection={true}
        toggleSelectItem={(data) => {
          shareDataDetail?.setSelectedFiles(data);
        }}
      />
    </MainPageDialog>
  );
};

export default AttchBillingData;
